var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.renderClosedApp
    ? _c("section", { staticClass: "vn-curation__closed" }, [
        _c("h2", { staticClass: "vn-curation__h" }, [_vm._v("모집 마감 강의")]),
        _vm._v(" "),
        _c("div", { staticClass: "vn-curation__select" }, [
          _c(
            "ul",
            { staticClass: "vn-card-closed" },
            _vm._l(_vm.closedCoursesList, function (closedCourse) {
              return _c("li", { key: closedCourse.id }, [
                _c(
                  "a",
                  {
                    staticClass: "vn-card-closed__item",
                    attrs: { href: "/courses/" + closedCourse.id },
                  },
                  [
                    _c("div", { staticClass: "vn-card-closed__info" }, [
                      closedCourse.prerequisite
                        ? _c("div", { staticClass: "vn-card-closed__label" }, [
                            _c("span", { staticClass: "label label--name" }, [
                              _vm._v(_vm._s(closedCourse.prerequisite)),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("dl", { staticClass: "vn-card-ended__desc" }, [
                        _c("dt", [_vm._v(_vm._s(closedCourse.title))]),
                        _vm._v(" "),
                        _c("dd", [_vm._v(_vm._s(closedCourse.description))]),
                      ]),
                    ]),
                  ]
                ),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn-group" }, [
          _vm.renderMoreButton
            ? _c(
                "button",
                {
                  staticClass: "btn btn--lg btn--white vn-curation__more",
                  attrs: { type: "button" },
                  on: { click: _vm.viewClosedCourses },
                },
                [_vm._v("\n      모집 마감 강의 더 보기\n    ")]
              )
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }